import {styled} from '@esgi/ui/theme';
import {Text} from '@esgi/ui/typography';

export const CenteredText = styled(Text, {
	textAlign: 'center',
});
